<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 w-screen"
  >
    <div
      class="flex justify-center items-center w-full max-w-md bg-white p-4 rounded-xl shadow-lg"
    >
      <!-- Import File Content -->
      <div v-if="isuploadFile" class="flex flex-col w-full">
        <div class="flex justify-start">
          <h1 class="font-semibold text-lg text-gray-800">Upload Image</h1>
        </div>

        <!-- Drag & Drop File Upload -->
        <div
          class="flex justify-center items-center cursor-pointer border-2 border-dashed border-gray-300 rounded-md p-8 w-full max-w-xl mx-auto mt-3"
          :class="{ 'bg-gray-100': dragging }"
          @dragover.prevent="onDragOver"
          @dragleave.prevent="onDragLeave"
          @drop.prevent="onDrop"
          @click="triggerFileInput"
        >
          <div class="text-center">
            <p v-if="!file" class="text-gray-600">
              <span class="text-green1">Upload a file</span> or drag and drop<br />
              PNG up to 10MB
            </p>
            <p v-else class="text-green-600">File uploaded: {{ file.name }}</p>
            <input
              type="file"
              class="hidden"
              ref="fileInput"
              @change="onFileChange"
              accept=".csv"
            />
          </div>
        </div>

        <!-- Reminders -->
        <div class="mt-3 text-[13px] flex justify-between">
          <div>
            <p class="text-gray-600">Accepted Files: .png</p>
            <p class="text-green-700">example.png</p>
          </div>
        </div>

        <!-- Action Buttons -->
        <!-- Break Line  -->
        <div class="w-full h-[1px] rounded-md bg-gray-200 mt-4"></div>
        <!-- Buttons  -->
        <div class="tracking-wide flex justify-end gap-2 mt-4">
          <button
            class="bg-red-600 p-2 px-3 rounded-md text-white hover:bg-white border hover:border-red-800 hover:text-red-800 hover:shadow-md"
            @click="closeModal"
          >
            Cancel
          </button>
          <button
            class="bg-green-600 p-2 px-3 rounded-md text-white hover:bg-white border hover:border-green-800 hover:text-green-800 hover:shadow-md"
            @click="uploadFile"
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Confirmation Modal -->
  <!-- <ConfirmedSubmitted
    v-if="isConfirmedSubmitted"
    @close="isConfirmedSubmitted = false"
  /> -->
</template>

<script>
// import axios from "axios";
// import ConfirmedSubmitted from "../../global/alert/confirmed-submitted.vue";

export default {
  name: "UploadImage",
  components: {
    // ConfirmedSubmitted,
  },
  data() {
    return {
      isOpen: true,
      isConfirmedSubmitted: false,
      isuploadFile: true,
      dragging: false,
      file: null,
      loading: false,
      message: "",
    };
  },
  methods: {
    onDragOver() {
      this.dragging = true;
    },
    onDragLeave() {
      this.dragging = false;
    },
    onDrop(event) {
      this.dragging = false;
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.handleFile(files[0]);
      }
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.handleFile(file);
      }
    },
    handleFile(file) {
      if (!file.name.endsWith(".csv")) {
        alert("Only CSV files are allowed!");
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        alert("File size exceeds 10MB limit!");
        return;
      }
      this.file = file;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async uploadFile() {},
    closeModal() {
      this.isOpen = false;
      this.$emit("close");
    },
  },
};
</script>
